import { Text } from "@fluentui/react-components";
import React from "react";
import { useIntl } from "react-intl";

import { ErrorContext, NotificationType } from "./slice";


export interface IErrorInformation {
  errorContext?: ErrorContext;
  className?: string;
  notificationType?: NotificationType;
}

export const ErrorInformations: React.FC<IErrorInformation> = ({ errorContext, className, notificationType }) => {
  const intl = useIntl();
  if (notificationType === NotificationType.Error && errorContext?.correlationId) {
    return (
      <Text aria-live="polite" className={className}>
        {intl.formatMessage(
          {
            defaultMessage: "(Tracking info: {correlationId} {timestamp} | Status code: {statusCode})",
            description: "The error correlation messages which contain the id and the timestamp.",
          },
          {
            correlationId: errorContext.correlationId,
            timestamp: errorContext.timestamp,
            statusCode: errorContext.statusCode
          }
        )}
      </Text>
    );
  } else {
    return null;
  }
};
